// extracted by mini-css-extract-plugin
module.exports = {"wrapperCard":"CompanyCranesStatus_wrapperCard__3LDt9","companyName":"CompanyCranesStatus_companyName__1SD9Q"};